import Modal from "components/ui/modal/Modal";
import { ModalSections, ModalTitle } from "./LearnMoreModalContent";
import McpProviderInstructions from "./McpProviderInstructions";
import type { McpProvider } from "./mcpProviders";

type Props = {
  provider: McpProvider;
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export default function McpLearnMoreModal({ provider, open, onOpenChange }: Props): JSX.Element {
  return (
    <Modal open={open} onOpenChange={onOpenChange} width="560px" padding={24}>
      <ModalSections>
        <ModalTitle>{provider.modalTitle}</ModalTitle>
        {/* One child rather than a bare fragment: `ModalSections` spaces its children with a flex
            gap, and the instructions space themselves with margins, so spreading them here would
            apply both. */}
        <div>
          <McpProviderInstructions provider={provider} showServerUrl />
        </div>
      </ModalSections>
    </Modal>
  );
}
